import React from 'react';
import StatusContainer from '~/components/organism/StatusContainer';
import useCurrentAccount from '~/hooks/useCurrentAccount';
import { MASTER_ACCOUNT_ID } from '~/util/constants';

const text = {
  warningAfterAdding:
    'Zorg ervoor dat je de flows activeert en deelt zodat ze als templates gebruikt kunnen worden in andere accounts.',
};

const MasterAccountWarning = () => {
  const account = useCurrentAccount();

  if (account.id !== MASTER_ACCOUNT_ID) return null;

  return <StatusContainer level="warning" label={text.warningAfterAdding} />;
};

export default MasterAccountWarning;
